import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/products", label: "Products" },
  { path: "/infrastructure", label: "Infrastructure" },
  { path: "/gallery", label: "Gallery" },
  { path: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "glass-header shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-24">
        {/* Logo */}
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logo-icon.svg" alt="JSY" className="w-20 h-20 object-contain" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                location.pathname === l.path
                  ? "text-[#1D4ED8]"
                  : "text-[#71717A] hover:text-[#09090B]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta"
            className="btn-primary ml-3 text-sm py-2 px-5"
          >
            <Phone size={14} /> Get Quote
          </Link>
        </nav>

        {/* Mobile Toggle */}
        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t border-[#E4E4E7] px-6 py-4 space-y-1"
        >
          {NAV_LINKS.map((l) => (
            <Link
              key={l.path}
              to={l.path}
              className={`block px-4 py-3 text-sm font-medium rounded ${
                location.pathname === l.path
                  ? "text-[#1D4ED8] bg-[#EBF0FF]"
                  : "text-[#71717A]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary w-full justify-center mt-3 text-sm py-3">
            <Phone size={14} /> Get Quote
          </Link>
        </div>
      )}
    </header>
  );
}
